import type { ModernSubscription } from '../../types';
import { SubscriptionTypes } from '../../types';

export function isMarketplace(modernSubscription: ModernSubscription) {
  return modernSubscription.subscriptionType === SubscriptionTypes.MARKETPLACE;
}
